import { FilmSynopsisLength } from '../types/film-synopsis-length';
export const getFilmSynopsisByLength = (film, length) => {
    switch (length) {
        case FilmSynopsisLength.FullOnly:
            return film.synopsis;
        case FilmSynopsisLength.Longest:
            return film.synopsis || film.shortSynopsis;
        case FilmSynopsisLength.ShortOnly:
            return film.shortSynopsis;
        case FilmSynopsisLength.Shortest:
        default:
            return film.shortSynopsis || film.synopsis;
    }
};
